import React, { useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { QRCode } from 'react-qrcode-logo';
import logo from './OV-WarrantyMS.png';

  
  const QRCodeDialog = ({ open, onClose, qrData }) => {
    const qrCodeRef = useRef(null);
  
    const handleDownload = () => {
      if (qrCodeRef.current) {
        const canvas = qrCodeRef.current.querySelector('canvas');
        if (canvas) {
          const link = document.createElement('a');
          link.href = canvas.toDataURL('image/png');
          link.download = 'QRCode.png';
          link.click();
        }
      }
    };
  
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>
          Scan QR Code
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div ref={qrCodeRef} style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
            <QRCode
              value={qrData}
              size={256}
              logoImage={logo}
              removeQrCodeBehindLogo={true}
              logoPaddingStyle="circle"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDownload} variant="contained" color="primary">
            Download as PNG
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default QRCodeDialog;
  